export default __webpack_public_path__ + "static/media/Telegram.0d009c1e.svg";